module.exports = __webpack_public_path__ + "static/media/logo-mobile.2300c912.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-mobile.svg
// module id = 137
// module chunks = 0